class BookingController {
    constructor($translate, cacheService) {
        'ngInject';
        this.$translate = $translate;
        this.cacheService = cacheService;
        this.message = false;

        this.STATUS_OK = 'ok';
        this.STATUS_DISABLED = 'disabled';
        this.STATUS_PENDING_CRC = 'pending_crc';
        this.STATUS_NOT_CANCELLABLE = 'not_cancellable';
    }

    $onInit() {
        this.translations = this.$translate.instant([
            'msg_7',
            'tab_title_view',
            'tab_title_amend',
            'tab_title_cancel',
            'customer',
            'payment_reference',
            'crc_confirmed'
        ]);

        this.translations.mainTitleKey = "";
        if(this.data !== null){
            if (this.data.status_amend === this.STATUS_PENDING_CRC) {
                this.message = {
                    class: 'st-alert--danger',
                    role: 'alert',
                    type: 'danger',
                    text: this.translations.msg_7
                }
            }else if(this.data.status_amend === this.STATUS_OK && this.cacheService.get('statusAmendUpdated') === true){
                this.message = {
                    class: 'st-alert--success',
                    role: 'alert',
                    type: 'success',
                    text: this.translations.crc_confirmed
                };
                this.cacheService.set('statusAmendUpdated', false);
            }
        }

    }
}

export default BookingController;


// WEBPACK FOOTER //
// ./client/app/routes/bookings/booking/booking.controller.js